<template>
  <div class="components-forum-category-item">
    <button
      class="mx-lg-5 mx-4 d-flex flex-column align-items-center position-relative"
      @click="$emit('select-item')"
    >
      <div
        class="p-3"
        :class="{ 'border-img': !selected, 'bg-active': selected }"
      >
        <img :src="url" :alt="alt" class="img-fluid" />
      </div>
      <img
        src="@/assets/images/forum/icon-check.svg"
        alt="check-icon"
        height="20"
        width="20"
        class="position-absolute check-icon"
        :class="{ 'd-none': !selected }"
      />
    </button>
  </div>
</template>

<script>
export default {
  name: "CategoryItem",
  props: {
    url: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.components-forum-category-item {
  button {
    background: none;
    border: none;
    color: #ffffff;
  }
  .border-img,
  .bg-active {
    border: 1px solid #ffffff;
    border-radius: 50%;
    width: 78px;
    height: 78px;
  }

  .bg-active {
    background-color: #2db563;
    border: none;
  }

  .check-icon {
    top: 4px;
    right: 10px;
    border-radius: 50%;
  }
}
</style>
